import {
  Grid,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  TextField,
  InputAdornment,
  ListSubheader,
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import React, { useEffect, useState } from 'react'
import TemplateLib from '@common/libs/template-lib'

export default function Paiement(props) {
  const { _formData, set_formData } = props
  const [stripeProducts, setStripeProducts] = useState([])
  const [selectedPriceIds, setSelectedPriceIds] = useState(
    _formData.actions[0].data.price_ids ? _formData.actions[0].data.price_ids : []
  )
  const [loading, setLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  console.log('_formData', _formData)

  useEffect(() => {
    // Fetch Stripe products
    fetchStripeProducts()
  }, [])

  const fetchStripeProducts = async () => {
    setLoading(true)
    try {
      const products = await TemplateLib.getStripeProducts()
      console.log('products', products)
      setStripeProducts(products)
      setLoading(false)
    } catch (error) {
      console.error('Error fetching Stripe products:', error)
      setLoading(false)
    }
  }

  const handleProductSelect = (event) => {
    const priceIds = event.target.value.filter((id) => id)
    setSelectedPriceIds(priceIds)

    const selectedProductsArray = stripeProducts.filter((p) =>
      priceIds.includes(p.default_price?.id)
    )
    const productNames = selectedProductsArray.map((p) => p.name)

    console.log('selected products', productNames.join(', '))

    // Update form data with selected products' default prices
    const state = {
      ..._formData.actions[0].data,
      price_ids: priceIds,
    }

    set_formData({
      ..._formData,
      actions: [{ ..._formData.actions[0], data: state }],
    })
  }

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value)
  }

  // Filter products based on search term
  const filteredProducts = stripeProducts.filter((product) =>
    searchTerm.split(' ').every((term) => product.name.toLowerCase().includes(term.toLowerCase()))
  )

  return (
    <Grid container spacing={3}>
      {/* Product Selection */}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Sélectionner des produits Stripe</InputLabel>
          <Select
            multiple
            value={selectedPriceIds}
            onChange={handleProductSelect}
            label="Sélectionner des produits Stripe"
            disabled={loading}
            renderValue={(selected) => (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {selected.map((value) => {
                  const product = stripeProducts.find((p) => p.default_price?.id === value)
                  return (
                    <Chip
                      key={value}
                      label={product ? product.name : value}
                      style={{ margin: 2 }}
                    />
                  )
                })}
              </div>
            )}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
              // This is important to keep the dropdown open while typing in the search field
              autoFocus: false,
              disableAutoFocusItem: true,
            }}
          >
            <ListSubheader
              style={{
                backgroundColor: 'white',
                position: 'sticky',
                top: 0,
                zIndex: 1,
                padding: '8px',
              }}
            >
              <TextField
                size="small"
                variant="outlined"
                placeholder="Rechercher..."
                value={searchTerm}
                onChange={handleSearchChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                // These prevent the dropdown from closing when interacting with the search field
                onKeyDown={(e) => e.stopPropagation()}
                onClick={(e) => e.preventDefault()}
              />
            </ListSubheader>

            {loading ? (
              <MenuItem value="">
                <CircularProgress size={20} />
              </MenuItem>
            ) : filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <MenuItem key={product.default_price?.id} value={product.default_price?.id}>
                  {product.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>Aucun produit trouvé</MenuItem>
            )}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  )
}
